import React from 'react';
import PropTypes from 'prop-types';

import { Section } from '../../Section';
import { Select } from '../../Select';

import { InputWrapper } from './styles';

const renderSelectComponent = ({
	label,
	name,
	value,
	options,
	version,
	onChange,
}) => (
	<InputWrapper>
		<Select
			label={label}
			name={name}
			options={options}
			value={value}
			onChange={event => {
				const value = event.target.value;
				const data = options.find(item => item.value === value);

				onChange({
					[event.target.name]: {
						version,
						data,
					},
				});
			}}
		/>
	</InputWrapper>
);

export const CompanyInfoSection = ({
	metadataOptions = {},
	exportedMetadata = {},
	animationIndex,
	onChange,
}) => {
	return (
		<Section title="Company information" animationIndex={animationIndex}>
			<React.Fragment>
				{renderSelectComponent({
					label: 'Industry',
					name: 'industry',
					value:
						exportedMetadata.industry && exportedMetadata.industry.data
							? exportedMetadata.industry.data.value
							: null,
					options: metadataOptions.industries.data || [],
					version: metadataOptions.industries.version,
					onChange,
				})}
				{renderSelectComponent({
					label: 'Revenue',
					name: 'revenue',
					value:
						exportedMetadata.revenue && exportedMetadata.revenue.data
							? exportedMetadata.revenue.data.value
							: null,
					options: metadataOptions.revenues.data || [],
					version: metadataOptions.revenues.version,
					onChange,
				})}
				{renderSelectComponent({
					label: 'Number of employees',
					name: 'employeesNumber',
					value:
						exportedMetadata.employeesNumber &&
						exportedMetadata.employeesNumber.data
							? exportedMetadata.employeesNumber.data.value
							: null,
					options: metadataOptions.employeesNumberBands.data || [],
					version: metadataOptions.employeesNumberBands.version,
					onChange,
				})}

				{renderSelectComponent({
					label: 'Head office location',
					name: 'headOfficeLocation',
					value:
						exportedMetadata.headOfficeLocation &&
						exportedMetadata.headOfficeLocation.data
							? exportedMetadata.headOfficeLocation.data.value
							: null,
					options: metadataOptions.headOfficeLocations.data || [],
					version: metadataOptions.headOfficeLocations.version,
					onChange,
				})}
			</React.Fragment>
		</Section>
	);
};

CompanyInfoSection.propTypes = {
	animationIndex: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
};
